var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// ONIX contributor role code (List 17) of an author.
var AUTHOR_ROLE = "A01";
var YEAR_PATTERN = /\d{4}/;
/**
 * Publication year of a product from its partial publishing date
 * ("yyyy", "mm.yyyy" or "dd.mm.yyyy"); undefined when the date carries no year.
 */
export var getPublicationYear = function (product) {
    var _a, _b;
    var publishingDate = (_a = product.publishingDate) === null || _a === void 0 ? void 0 : _a.trim();
    if (!publishingDate) {
        return undefined;
    }
    var lastSegment = publishingDate.split(".").pop() || "";
    if (/^\d{4}$/.test(lastSegment)) {
        return lastSegment;
    }
    return (_b = publishingDate.match(YEAR_PATTERN)) === null || _b === void 0 ? void 0 : _b[0];
};
var bySequenceNumber = function (a, b) {
    var _a, _b;
    return ((_a = a.sequenceNumber) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER) -
        ((_b = b.sequenceNumber) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER);
};
var isAuthor = function (contribution) {
    return (contribution.roles || []).some(function (contributionRole) { var _a; return ((_a = contributionRole.role) === null || _a === void 0 ? void 0 : _a.value) === AUTHOR_ROLE; });
};
// Same precedence as the backend search lists: person name, corporate name,
// unnamed person.
var formatContributorName = function (contribution) {
    var _a, _b, _c;
    var personName = [contribution.firstName, contribution.lastName]
        .map(function (part) { return part === null || part === void 0 ? void 0 : part.trim(); })
        .filter(Boolean)
        .join(" ");
    return (personName ||
        ((_a = contribution.name) === null || _a === void 0 ? void 0 : _a.trim()) ||
        ((_b = contribution.unnamedPerson) === null || _b === void 0 ? void 0 : _b.description) ||
        ((_c = contribution.unnamedPerson) === null || _c === void 0 ? void 0 : _c.value) ||
        undefined);
};
/**
 * Name of the first author of the product's title: the contributor with the
 * author role (A01) and the lowest sequence number, otherwise the first
 * contributor of any role.
 */
export var getFirstAuthorName = function (product) {
    var _a, _b;
    var contributions = __spreadArray([], (((_a = product.title) === null || _a === void 0 ? void 0 : _a.titleContributions) || []), true).sort(bySequenceNumber);
    var firstAuthor = (_b = contributions.find(isAuthor)) !== null && _b !== void 0 ? _b : contributions[0];
    return firstAuthor ? formatContributorName(firstAuthor) : undefined;
};
